"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logGroup = void 0;
const logGroup = (title, items) => {
    console.group(title);
    for (const key in items) {
        console.groupCollapsed(key);
        console.log(items[key]);
        console.groupEnd();
    }
    console.groupEnd();
};
exports.logGroup = logGroup;
//# sourceMappingURL=logUtils.js.map